import styled from 'styled-components'
import { clickDown, clickUp, diceRotate } from '../../../animations/Transitions'
import { cyberColors } from '../../../lib/colors'
import { BUTTON_STYLED_PROPS } from './interface'
interface content_style_props {
  anim: boolean
}

export const ButtonDiv = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isDisabled, startAuto }: any) =>
    isDisabled || startAuto ? 'auto' : 'pointer'};
  pointer-events: ${({ isDisabled, startAuto }: any) =>
    isDisabled || startAuto ? 'none' : 'auto'};
  width: ${({ width }: any) => width || '150px'};
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    background: ${({ background }: any) => background};
    height: ${({ height }: any) => height || '50px'};
    width: ${({ width }: any) => width || '150px'};
    margin: ${({ margin }: any) => margin || '0px'};
    color: ${({ color }: any) => color || cyberColors.whiteText};
    border-radius: ${({ radius }: any) => radius || '4px'};
    opacity: ${({ isDisabled, startAuto }: any) =>
      isDisabled || startAuto ? 0.5 : 1};
    font-size: ${({ size }: any) => size || '12px'};
    box-shadow: ${({ shadow }: any) => shadow || 'none'};
    cursor: ${({ isDisabled, startAuto }: any) =>
      isDisabled || startAuto ? 'not-allowed' : 'pointer'};
    pointer-events: ${({ isDisabled, startAuto }: any) =>
      isDisabled || startAuto ? 'none' : 'auto'};
    clip-path: inset(0.5px 0px 0px 0.5px);
    transition: opacity 0.2s;
    ${clickUp}
  }
  p {
    margin: 0px 6px;
    font-family: ${({ font }: any) => font || 'Regular'};
    transform: translateY(3px);
  }
  span {
    color: ${({ stakeColor }: any) => stakeColor || cyberColors.whiteText};
    font-family: ${({ font }: any) => font || 'Regular'};
    transform: translateY(3px);
    max-width: 90px;
    text-overflow: ellipsis;
    overflow: hidden;
    /* padding-bottom: 2px; */
  }
  svg {
    margin: ${({ margin }: any) => margin || '0px'};
  }
  :active {
    .btn {
      ${clickDown}
    }
  }
`
export const Content = styled.div<content_style_props>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-left: 12px;
    ${({ anim }) => anim && diceRotate};
  }
  &&.auto {
    p {
      margin-left: 0;
    }
  }
`
